// this_week page
import React from 'react';
import { createRoot } from 'react-dom/client';
import { createStore, combineReducers, bindActionCreators } from 'redux';
import { connect, Provider } from 'react-redux';
import { ThemeProvider } from '@workboard/wobo-ui';
import MyworkDetailsReducer from '../../reducers/this_week.reducers';
import * as MyworkActions from '../../actions/this_week.actions';
import SPSApp from '../../apps/sps';


const mapsStateToPropsMeeting = state => ({
  myWorkData: state,
});

const mapsDispatchToPropsMeeting = dispatch => ({
  actions: bindActionCreators(MyworkActions, dispatch),
});

const SPSAppComp = connect(mapsStateToPropsMeeting, mapsDispatchToPropsMeeting)(SPSApp);

const SPSAppWobo = function (data) {
  const myworkStore = createStore(MyworkDetailsReducer, data);
  createRoot(document.getElementById('SPSAppWobo')).render(
    <Provider store={myworkStore}>
      <ThemeProvider>
        <SPSAppComp />
      </ThemeProvider>
    </Provider>,
  );
};

window.SPSAppWobo = SPSAppWobo;
